/* eslint-disable */

module.exports = require('./build/index.js');
